var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"boxTitle"},[_vm._v("中国与七大洲贸易额")]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('dv-active-ring-chart',{staticStyle:{"width":"250px","height":"18vh"},attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76416a03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/right/five.vue
// module id = null
// module chunks = 